import { date } from "yup"
import { ErrorMessages } from "logics/const"

export default function dateOptional() {
  return date().nullable().typeError(ErrorMessages.NotNumber)
}
